import React from 'react';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import PeopleIcon from '@mui/icons-material/People';
import FolderIcon from '@mui/icons-material/Folder';
import LockIcon from '@mui/icons-material/Lock';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BarChartIcon from '@mui/icons-material/BarChart';
import SendIcon from '@mui/icons-material/Send';
import InsightsIcon from '@mui/icons-material/Insights';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CategoryIcon from '@mui/icons-material/Category';

import { ROUTES } from './routes';

export interface NavItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}

export const MY_WORK_ITEMS: NavItem[] = [
  { label: 'Timesheet', path: ROUTES.TIMESHEET, icon: <AccessTimeIcon /> },
  { label: 'My Submits', path: ROUTES.MY_SUBMITS, icon: <SendIcon /> },
  { label: 'Time Off', path: ROUTES.TIME_OFF, icon: <BeachAccessIcon /> },
  { label: 'Analytics', path: ROUTES.ANALYTICS, icon: <InsightsIcon /> },
  { label: 'My Projects', path: ROUTES.MY_PROJECTS, icon: <FolderIcon /> },
];

export const REPORT_ITEMS: NavItem[] = [
  { label: 'Summary Report', path: ROUTES.REPORTS.SUMMARY, icon: <BarChartIcon /> },
];

export const PM_REPORT_ITEMS: NavItem[] = [
  { label: 'Time Audit', path: ROUTES.REPORTS.TIME_AUDIT, icon: <FactCheckIcon /> },
];

export const MANAGER_ITEMS: NavItem[] = [
  { label: 'Approvals', path: ROUTES.APPROVALS, icon: <CheckCircleIcon /> },
  { label: 'PM Dashboard', path: ROUTES.DASHBOARD_PM, icon: <TrendingUpIcon /> },
  { label: 'Projects', path: ROUTES.SETTINGS.PROJECTS, icon: <FolderIcon /> },
];

export const ADMIN_ITEMS: NavItem[] = [
  { label: 'Activities', path: ROUTES.SETTINGS.ACTIVITIES, icon: <CategoryIcon /> },
  { label: 'Resources', path: ROUTES.SETTINGS.RESOURCES, icon: <PeopleIcon /> },
  { label: 'Permissions', path: ROUTES.SETTINGS.PERMISSIONS, icon: <LockIcon /> },
  { label: 'Working Hours', path: ROUTES.SETTINGS.WORKING_HOURS, icon: <ScheduleIcon /> },
  { label: 'Delegations', path: ROUTES.SETTINGS.DELEGATIONS, icon: <SwapHorizIcon /> },
];

const FULL_MODE_ONLY_PATHS: string[] = [
  ROUTES.MY_SUBMITS,
  ROUTES.ANALYTICS,
  ROUTES.APPROVALS,
  ROUTES.DASHBOARD_PM,
  ROUTES.SETTINGS.ACTIVITIES,
];

export const filterNavItems = (items: NavItem[], isFullMode: boolean): NavItem[] => {
  if (isFullMode) {
    return items;
  }
  return items.filter(item => !FULL_MODE_ONLY_PATHS.includes(item.path));
};
